import api from './api.js';
import { getUiLanguage } from '../Utils/uiLocale.js';

export const orgAPI = {
    getProfile: () => api.get('/api/org/profile'),
    updateProfile: (payload) => api.patch('/api/org/profile', payload),
    // Plan names, descriptions and features come back in the current UI language.
    getBilling: () => api.get('/api/org/billing', { params: { lang: getUiLanguage() } }),
    createCheckout: (planId, interval = 'monthly', returnPath) =>
        api.post('/api/org/billing/checkout', { planId, interval, returnPath }),
    createPaymosCheckout: (planId, interval = 'monthly', returnPath, months = 1) =>
        api.post('/api/org/billing/checkout/paymos', { planId, interval, returnPath, months }),
    createNowPaymentsCheckout: (planId, interval = 'monthly', returnPath, months = 1) =>
        api.post('/api/org/billing/checkout/nowpayments', {
            planId,
            interval,
            returnPath,
            months,
        }),
    createPortal: () => api.post('/api/org/billing/portal'),
    contactSales: (payload) => api.post('/api/org/billing/contact-sales', payload),
};
